/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Salary_Upgrade_TitleInputs */

const en_salary_upgrade_title = /** @type {(inputs: Salary_Upgrade_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Upgrade to unlock Salary Intelligence`)
};

const de_salary_upgrade_title = /** @type {(inputs: Salary_Upgrade_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Upgrade, um Gehaltsintelligenz freizuschalten`)
};

const fr_salary_upgrade_title = /** @type {(inputs: Salary_Upgrade_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Passe à un plan supérieur pour débloquer l'intelligence salariale`)
};

const es_salary_upgrade_title = /** @type {(inputs: Salary_Upgrade_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mejore su plan para desbloquear Inteligencia salarial`)
};

const it_salary_upgrade_title = /** @type {(inputs: Salary_Upgrade_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aggiorna per sbloccare l'intelligenza salariale`)
};

const nl_salary_upgrade_title = /** @type {(inputs: Salary_Upgrade_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Upgrade om Salarisintelligentie te ontgrendelen`)
};

const pl_salary_upgrade_title = /** @type {(inputs: Salary_Upgrade_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ulepsz, aby odblokować inteligencję wynagrodzeń`)
};

const fi_salary_upgrade_title = /** @type {(inputs: Salary_Upgrade_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Päivitä avataksesi Palkkatiedon`)
};

const da_salary_upgrade_title = /** @type {(inputs: Salary_Upgrade_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opgrader for at låse Lønoplysninger op`)
};

const sv_salary_upgrade_title = /** @type {(inputs: Salary_Upgrade_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uppgradera för att låsa upp Löneinformation`)
};

/**
* | output |
* | --- |
* | "Upgrade to unlock Salary Intelligence" |
*
* @param {Salary_Upgrade_TitleInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const salary_upgrade_title = /** @type {((inputs?: Salary_Upgrade_TitleInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Salary_Upgrade_TitleInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_salary_upgrade_title(inputs)
	if (locale === "fr") return fr_salary_upgrade_title(inputs)
	if (locale === "es") return es_salary_upgrade_title(inputs)
	if (locale === "it") return it_salary_upgrade_title(inputs)
	if (locale === "nl") return nl_salary_upgrade_title(inputs)
	if (locale === "pl") return pl_salary_upgrade_title(inputs)
	if (locale === "fi") return fi_salary_upgrade_title(inputs)
	if (locale === "da") return da_salary_upgrade_title(inputs)
	if (locale === "sv") return sv_salary_upgrade_title(inputs)
	return en_salary_upgrade_title(inputs)
});